import PropTypes from 'prop-types';
function TeacherStatsMoneyRaised({ lifetimePaymentAmountReceived, thisYearPaymentAmountReceived, lastYearPaymentAmountReceived, isTeacher }) {
    if (!lifetimePaymentAmountReceived) return null;

    const moneyRaisedText = isTeacher ? 'Donations you\'ve raised for your classroom:' : 'Donations they\'ve raised for their classroom';

    function sidePanel() {
        if (thisYearPaymentAmountReceived || lastYearPaymentAmountReceived) {
            return (
                <div className='previous-years'>
                    {thisYear()}
                    {lastYear()}
                </div>
            );
        }
    }

    function thisYear() {
        if (thisYearPaymentAmountReceived) {
            return (
                <div className='this-year'>
                    <h4>and This Year:</h4>
                    <div className='amount'>${thisYearPaymentAmountReceived.toLocaleString('en-US')}</div>
                </div>
            );
        }
    }

    function lastYear() {
        if (lastYearPaymentAmountReceived) {
            return (
                <div className='previous-year'>
                    <h4>Last Year, you raised:</h4>
                    <div className='amount'>${lastYearPaymentAmountReceived.toLocaleString('en-US')}</div>
                </div>
            );
        }
    }

    return (
        <section className='moneyRaisedWrapper'>
            <div className='moneyRaised'>
                <h3>{moneyRaisedText}</h3>
                <div className='amount'>$ {lifetimePaymentAmountReceived.toLocaleString('en-US')}</div>
            </div>
            { sidePanel() }
        </section>);
}

TeacherStatsMoneyRaised.propTypes = {
    lifetimePaymentAmountReceived: PropTypes.number,
    thisYearPaymentAmountReceived: PropTypes.number,
    lastYearPaymentAmountReceived: PropTypes.number,
    isTeacher: PropTypes.bool,
};

export default TeacherStatsMoneyRaised;
